import { pollArchivedQaJob } from './qaWorkbookRequests';

export async function requestArchivedSovDownload(document, options, { authenticate, invoke, requestId, pollOptions }) {
  const user = await authenticate({ bypassCache: true });
  const job = await pollArchivedQaJob(invoke, { target: 'prepare-archived-qa-sov-workbook', document_id: document.document_id,
    archivedQa: document.archivedQa, requestId: requestId(), access_token: user.signInUserSession.idToken.jwtToken,
    removeTransformedSheets: options.removeTransformedSheets, consolidatedSheetName: options.consolidatedSheetName,
    summarySheetName: options.summarySheetName, documentFileName: options.documentFileName,
    headersInfo: { includeHeaders: options.headersInfo?.includeHeaders === true && options.headersInfo?.tempArrayBuffer != null
      && Number.isSafeInteger(options.headersInfo?.sheetIndex) && options.headersInfo.sheetIndex >= 0 } }, pollOptions);
  return { eligible: true, path: job.outputs.workbookPath, fileName: job.outputs.fileName };
}
